export const rfidConstants = {
    REQUEST_DROPDOWN_LIST: "REQUEST_DROPDOWN_LIST",
    SUCCESS_DROPDOWN_LIST: "SUCCESS_DROPDOWN_LIST",
    FAILURE_DROPDOWN_LIST: "FAILURE_DROPDOWN_LIST",
    REQUEST_UNUSED_LIST: "REQUEST_UNUSED_LIST",
    SUCCESS_UNUSED_LIST: "SUCCESS_UNUSED_LIST"
};